@if (dataSource.length > 0) {
  <div class="tab-overflow">
    <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
      @for (column of columns; track column.keyColumn) {
        <ng-container matColumnDef="{{ column.keyColumn }}">
          <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
          <td mat-cell *matCellDef="let element">
            @if (column.keyColumn == 'tg_evento') {
              <b>Tg:</b> {{ displayValue(element.codigoTg) }}<br />
              <b>Evento:</b> {{ displayValue(element.nomeEvento) }}
            } @else if (column.keyColumn == 'trecho') {
              <b>Origem:</b> {{ displayValue(element.origem) }}<br />
              <b>Destino:</b> {{ displayValue(element.destino) }}
            } @else if (column.keyColumn == 'periodo') {
              <b>Início:</b> {{ displayValue(element.dataInicio) }}<br />
              <b>Final:</b> {{ displayValue(element.dataFinal) }}
            } @else if (column.keyColumn == 'servico') {
              <b>Tipo:</b> {{ displayValue(element.descricaoTipoServico) }}<br />
              <b>Serviço:</b> {{ displayValue(element.descricaoServico) }}
            } @else if (column.keyColumn == 'veiculo') {
              <b>Tipo veículo:</b> {{ displayValue(element.descricaoTipoVeiculo) }}<br />
              <b>Tipo motorista:</b> {{ displayValue(element.descricaoTipoMotorista) }}
            } @else if (column.keyColumn == 'valores') {
              <b>Custo:</b> {{ formatCurrency(element.custo) }}<br />
              <b>Hora extra:</b> {{ formatCurrency(element.custoHoraExtra) }}<br />
              <b>Km extra:</b> {{ formatCurrency(element.custoKmExtra) }}
            } @else if (column.keyColumn == 'status') {
              <div class="flex flex-col gap-1">
                <span>{{ labelStatus(element) }}</span>
                @if (element.statusId === statusRecusado && element.motivoRecusaDescricao) {
                  <span
                    class="chip chip-warning"
                    [matTooltip]="element.obsRecusa ?? element.motivoRecusaDescricao"
                  >
                    {{ element.motivoRecusaDescricao }}
                  </span>
                }
              </div>
            } @else if (column.keyColumn == 'action') {
              <div class="flex justify-center items-center gap-3">
                @if (podeResponder(element)) {
                  <mat-icon
                    class="btn-icon-outline"
                    fontIcon="payments"
                    matTooltip="Informar valores"
                    (click)="openItemEvent(element)"
                  />
                } @else {
                  <mat-icon
                    class="btn-icon-outline"
                    fontIcon="visibility"
                    matTooltip="Visualizar"
                    (click)="openItemEvent(element)"
                  />
                }
              </div>
            } @else {
              {{ displayValue(element[column.key]) }}
            }
          </td>
        </ng-container>
      }
      <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}
